import * as actionTypes from '../actions/actionTypes';
import {
  updateObject
} from '../../shared/utility';

const initialState = {
  dhcpList: [],
  account:null,
  dhcp: null,
  error: false,
  success:false,
  loading: false,
  loaded:false,
  realDhcp:null,
  dhcpError: false
};
const resetDhcpState = (state, action) => {
  return updateObject(state, initialState)
}
const initDhcpStart = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: true,
    loaded:false
  });
};

const setDhcp = (state, action) => {
  return updateObject(state, {
    realDhcp: action.realDhcp,
    dhcpError: false,
    loading: false,
    loaded: true,
    added: false,
    edited: false
  });
};

const fetchDhcpFailed = (state, action) => {
  return updateObject(state, {
    loaded: true,
    loading: false,
    error: true
  });
};
const changeDhcpFailed = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: true
  });
};

const changeDhcpSuccess = (state, action) => {
  return updateObject(state, {
    loading: false,
    success: true
  });
};
const resetDhcpErrorSuccess = (state, action) => {
  return updateObject(state, {
    success:false,
    error:false
  })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INIT_DHCP_START:
      return initDhcpStart(state, action);
    case actionTypes.SET_DHCP:
      return setDhcp(state, action);
    case actionTypes.FETCH_DHCP_FAILED:
      return fetchDhcpFailed(state, action);
    case actionTypes.SET_DHCP_ERROR:
      return updateObject(state, { dhcpError: true, realDhcp: null, loading: false });
    case actionTypes.CHANGE_DHCP_SUCCESS:
      return changeDhcpSuccess(state, action);
    case actionTypes.CHANGE_DHCP_FAILED:
      return changeDhcpFailed(state, action);
    case actionTypes.RESET_DHCP_ERROR_SUCCESS:
      return resetDhcpErrorSuccess(state, action);
    default:
      return state;
  }
};

export default reducer;
